// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1JZil","header":"ClearentDisclaimer_header__1KD8X","inner":"ClearentDisclaimer_inner__34dPU"};